// The support level a case is funded at (`patient.level`). The L&G levels
// store their display text — legacy values, kept as they are in the cases.
// Newer levels store a slug and are shown through displaySupportLevel().
// What each level grants lives in supportLevelDefinitions.
export enum EbpCasePatientSupportLevel {
  One = 'Level 1',
  Two = 'Level 2',
  Three = 'Level 3',
  // Vitality (PPL-3720): every service is pre-authorised one by one, so the
  // level has no end of support and no session cap
  ClinicalService = 'clinical-service',
}

const supportLevels: string[] = Object.values(EbpCasePatientSupportLevel);

export function isEbpCasePatientSupportLevel(
  value: unknown,
): value is EbpCasePatientSupportLevel {
  return typeof value === 'string' && supportLevels.includes(value);
}

export function displaySupportLevel(level: EbpCasePatientSupportLevel) {
  switch (level) {
    case EbpCasePatientSupportLevel.One:
    case EbpCasePatientSupportLevel.Two:
    case EbpCasePatientSupportLevel.Three:
      return level;
    case EbpCasePatientSupportLevel.ClinicalService:
      return 'Clinical Service';
    default:
      throw new Error(`Unknown support level: ${level}`);
  }
}

// A case's stored level (patient.level is free text) for display; a value
// that is no longer a level shows as stored
export function displayStoredSupportLevel(level: string) {
  return isEbpCasePatientSupportLevel(level)
    ? displaySupportLevel(level)
    : level;
}
